module.exports = __webpack_public_path__ + "static/media/email-active.0e74436b.svg";